import { combineReducers } from "redux";

import userReducer from "./user/reducer";
import ambassadorReducer from "./ambassador/reducer";
import superUserReducer from "./superUser/reducer";
import companyReducer from "./company/reducer";
import notificationReducer from "./notification/reducer";
import embeddingsReducer from "./embeddings/reducer";
import profileReducer from "./profile/reducer";
import brgReducer from "./brg/reducer";
import programReducer from "./program/reducer";
import emailTemplateReducer from "./emailTemplate/reducer";
import dailyCronLogReducer from "./dailyCronLog/reducer";
import appSettingsReducer from "./appSettings/reducer";
import indiChallengeReducer from "./indiChallenge/reducer";
import promptReducer from "./prompt/reducer";

export default combineReducers({
	User: userReducer,
	Ambassador: ambassadorReducer,
	SuperUser: superUserReducer,
	Company: companyReducer,
	Notification: notificationReducer,
	Embeddings: embeddingsReducer,
	Profile: profileReducer,
	Brg: brgReducer,
	Program: programReducer,
	EmailTemplate: emailTemplateReducer,
	DailyCronLog: dailyCronLogReducer,
	AppSettings: appSettingsReducer,
	IndiChallenge: indiChallengeReducer,
	Prompt: promptReducer,
})